<template>
	<v-layout row wrap align-center justify-center>
		<v-flex xs12 sm8 class="mt-5">
			<v-card flat style="background-color: transparent!important;" class="mb-2">
				<v-card-title v-if="getStep <= 3">
					<p class="host-dashboard-title mb-0 pb-0" v-if="getStep <= 3">Your host application</p>
					<p class="host-dashboard-title mb-0 pb-0" v-else>Your host application is complete!</p>
				</v-card-title>
				<v-card-text>
					<v-layout row wrap align-center>
						<v-stepper vertical class="elevation-0" :value="getStepperStep" style="background: transparent;" v-if="getStep <= 3">
							<v-stepper-step step="1" :complete="getStepperStep > 1" class="host-dashboard-step">Personal Information</v-stepper-step>
							<v-stepper-step step="2" :complete="getStepperStep > 2" class="host-dashboard-step">
								Location Information
							</v-stepper-step>
						</v-stepper>
						<v-flex offset-md3 md4 offset-lg4 lg4 xs12 v-if="getStep <= 3">
							<div class="pa-3">
								<p class="host-dashboard-sub-title">You're almost done!</p>
								<p class="host-dashboard-content">It will only take a few minutes to finish your host application.</p>
								<v-btn block class="btn-blue" @click="goToCurrentStep">Continue Application</v-btn>
							</div>
						</v-flex>
						<v-flex xs12 sm12 md8 offset-md2 v-else>
							<v-card flat class="pa-3" style="background-color: transparent;">
								<p class="host-dashboard-sub-title">Thanks for applying to become a wrkprty host!</p>
								<p class="host-dashboard-content">
									Our team will review your application ASAP.
								</p>
								<p class="host-dashboard-content">
									Look out for an email follow-up from us soon.
								</p>
								<p class="host-dashboard-content">
									Once approved, you will be able to create your own event listings!
								</p>
								<v-btn block flat class="info" @click="goHome">Home</v-btn>
							</v-card>
						</v-flex>
					</v-layout>
				</v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
	created() {
		console.log('HostDashboard')
		let params = window.location.search.slice(1).split(/[\?\&]+/)
		for (let param in params) {
			let prop = params[param].split('=')[0]
			let value = params[param].split('=')[1]
			if (prop === 'host-application') {
				this.hostApplicationSuccessModal = true
			}
		}
	},
	methods: {
		...mapActions([
		]),
		goToCurrentStep() {
			if (this.getStep === 1) {
				this.$router.push('/host/apply')
			} else if (this.getStep === 2) {
				this.$router.push('/host/apply/space')
			} else if (this.getStep === 3) {
				this.$router.push('/host/add/location')
			}
		},
		goHome() {
			this.$router.push('/')
		}
	},
	computed: {
		...mapGetters([
			'getHostProp',
			'userHasHostRequest',
			'getHostProcessStep',
			'getHost',
			'userIsHost'
		]),
		getStep() {
			return this.getHostProcessStep
		},
		getStepperStep() {
			if (this.getStep < 3) {
				return 1
			} else {
				return 2
			}
		}
	}
}
</script>